import { FETCH_COLLECTIONS, SELECT_COLLECTION, UNSELECT_COLLECTION } from '@/redux/actions/collections.actions'
import { IGNORED_COLLECTION_APPLICATIONS } from '@/constants'

const initialState = {
	loading: false,
	list: [],
	bySubFamilyId: {},
	byApplicationId: {},
	selected: null
}

const loading = (state = initialState.loading, action) => {
	switch (action.type) {
		case FETCH_COLLECTIONS.REQUEST:
			return true
		case FETCH_COLLECTIONS.SUCCESS:
		case FETCH_COLLECTIONS.FAILURE:
			return false
		default:
			return state
	}
}

const list = (state = initialState.list, action) => {
	switch (action.type) {
		case FETCH_COLLECTIONS.SUCCESS:
			return action.payload.reduce((acc, collection) => {
				const subFamilyId = collection.subFamily.id
				if (IGNORED_COLLECTION_APPLICATIONS[subFamilyId]) {
					return [
						...acc,
						{
							...collection,
							applicationsLocations: collection.applicationsLocations.filter(appLoc => !IGNORED_COLLECTION_APPLICATIONS[subFamilyId].includes(appLoc.id))
						}	
					]
				}
				return [
					...acc,
					collection
				]
			}, [])
		case FETCH_COLLECTIONS.FAILURE:
		case FETCH_COLLECTIONS.REQUEST:
			return []
		default:
			return state
	}
}

const bySubFamilyId = (state = initialState.bySubFamilyId, action) => {
	switch (action.type) {
		case FETCH_COLLECTIONS.SUCCESS:
			return action.payload.reduce((acc, collection) => {
				const subFamilyId = collection.subFamily.id
				if (IGNORED_COLLECTION_APPLICATIONS[subFamilyId]) {
					return {
						...acc,
						[collection.subFamily.id]: {
							...collection,
							applicationsLocations: collection.applicationsLocations.filter(appLoc => !IGNORED_COLLECTION_APPLICATIONS[subFamilyId].includes(appLoc.id))
						}
					}
				}
				return {
					...acc,
					[collection.subFamily.id]: collection
				}
			}, {})
		case FETCH_COLLECTIONS.REQUEST:
		case FETCH_COLLECTIONS.FAILURE:
			return {}
		default:
			return state
	}
}

const byApplicationId = (state = initialState.byApplicationId, action) => {
	switch (action.type) {
		case FETCH_COLLECTIONS.SUCCESS:
			return action.payload.reduce((byApplicationId, collection) => {
				return collection.applicationsLocations.reduce((obj, applicationLocation) => {
					const subFamilyId = collection.subFamily.id
					const applicationId = applicationLocation.application.id
					if (IGNORED_COLLECTION_APPLICATIONS[subFamilyId] && IGNORED_COLLECTION_APPLICATIONS[subFamilyId].includes(applicationLocation.id)) {
						return obj
					}
					return {
						...obj,
						[applicationId]: {
							...applicationLocation.application,
							subFamilyIds: obj[applicationId]
								? [...obj[applicationId].subFamilyIds, collection.subFamily.id]
								: [collection.subFamily.id]
						}
					}
				}, byApplicationId)
			}, {})
		case FETCH_COLLECTIONS.REQUEST:
		case FETCH_COLLECTIONS.FAILURE:
			return {}
		default:
			return state
	}
}

const selected = (state = initialState.selected, action) => {
	switch (action.type) {
		case SELECT_COLLECTION: {
			const { applicationsLocations, ...collection } = action.payload
			return {
				...collection,
				...(applicationsLocations?.length === 1
					? { applicationLocation: applicationsLocations[0] }
					: { applicationsLocations })
			}
		}
		case UNSELECT_COLLECTION:
			return null
		default:
			return state
	}
}

export default {
	name: 'collections',
	reducers: {
		loading,
		list,
		bySubFamilyId,
		byApplicationId,
		selected
	}
}
